export default __webpack_public_path__ + "ac749fa00c9f806089159494cfc0befb.svg";